import { LicenseInfo } from '@mui/x-license';
import $ from 'jquery';
import _ from 'lodash';

$.noConflict();
_.noConflict();

LicenseInfo.setLicenseKey(
  '19967b21fcc9d99555eb82ae8520ad0fTz0xMTU1ODgsRT0xNzkzMzE4Mzk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y',
);

export { renderAccountManagementMenu } from './AccountManagementMenu';
export { renderLeftSideMenu } from './LeftSideMenu';
export { renderScheduleChangesDialog } from './ScheduleChangesDialog';
export { renderWorkflowsAdminView } from './WorkflowsAdminView';
export { renderUserActivityLogDialogComponent } from './UserActivityLogDialogComponent';
export { renderWorkflowsEmployeeProposalsDialog } from './WorkflowsEmployeeProposalsDialog';
export {
  WrappedCustomTranslationsValueList,
  CustomTranslationsValueList,
} from './CustomTranslationsValueList';
export { renderPortalTopBar } from './PortalTopBar';
export { renderOrganizationUnitPopup } from './OrganizationUnitPopup';
export { renderAbsencesTabContent } from './AbsencesTabContent';
export { renderPeopleCollaborationTabContent } from './PeopleCollaborationTabContent';
export { renderAnalyticsModuleViews } from './AnalyticsModuleViews';
export { renderChatBotDialog } from './AIChatbot';
export { renderChatBotButton } from './AIChatbot/components/ChatBotButton/component';
export { renderUserSettings } from './UserSettings';
export {
  generateSolaforcePDFFromElement,
  generateSolaforcePDFFromElementId,
} from './PDFExport';
export { unmountUI2LibraryComponent } from './utils';
export { updateUI2ReduxStores } from './utils/updateUI2ReduxStores';
